module.exports = __webpack_public_path__ + "static/media/signage-indoor-img11.0d62adb4.jpg";